import React, { Dispatch, useEffect, useRef, useState } from 'react';
import { isEmpty, DebouncedFunc } from "lodash";
import stableStringify from 'json-stable-stringify';

import '../../node_modules/react-grid-layout/css/styles.css'
import '../../node_modules/react-resizable/css/styles.css'
import { IInject, IScenario, ILayout, ITurnBrief } from '../interfaces';
import { useAppDispatch } from '../app/hooks'
import { publishInject } from '../features/injectSlice'
import RGLInject from './RGLInject'
import Modal from 'react-modal';
import Dropzone from './Dropzone';
import { Responsive, WidthProvider } from "react-grid-layout";
const RRGL = WidthProvider(Responsive);

interface Props {
  className?: string;
  rowHeight?: number;
  onLayoutChange?: (layout: ILayout) => void;
  cols?: { [P: string]: number; } | undefined;
  breakpoints?: { [index: string]: number };
  containerPadding?: [number, number] | { [P: string]: [number, number]; } | undefined;
  display: string;
  injectComponents: IInject[];
  gameTimeInterval: number;
  isSelected: string;
  id: string;
  updateShowHide: Dispatch<any>;
  setInjectComponents: Dispatch<IInject[]>;
  setInjectItem: Dispatch<IInject>;
  injectItem: IInject;
  clickBranches: Dispatch<any>;
  setZoomLevel: Dispatch<number>;
  zoomLevel: number;
  scenSnippets: ITurnBrief[];
  setSnippetModalIsOpen: Dispatch<boolean>;
  setSelectedSnippet: Dispatch<number>;
  setNewSnippet: Dispatch<ITurnBrief>;
  setSelectedScenario: Dispatch<IScenario>;
  selectedScenario: IScenario;
  showRGLTimeline: string;
  saveLayouts: any;
  setSaveLayouts: Dispatch<{ [index: string]: any[] }>;
  lastUserClick: string;
  setLastUserClick: Dispatch<string>;
  saveScenario: (i: IInject[]) => Promise<void>;
  createInjectComponents: Dispatch<{injects: any[]}>;
  onChangeSave: DebouncedFunc<any>;
  openDeleteModal: () => void;
  onError: Dispatch<string>;
}

Modal.setAppElement('#root');

  const customStyles = {
    content: {
      background: '#323544',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      padding: '0',
      border: 'none',
      width: '640px',
      transform: 'translate(-50%, -50%)'
    }
  };

const ReactGridLayout: React.FC<Props> = (props) => {

  const [layouts, setLayouts] = useState<{ [index: string]: ILayout[] }>({});
  let [modalInjectIsOpen, setModalInjectIsOpen] = useState<boolean>(false);
  let [breakpoints, setBreakpoints] = useState<{ [index: string]: number }>({injects: (props.gameTimeInterval * 357)});
  let [injectDetails, setInjectDetails] = useState<{ id: string, image: string, localImage: string, published: boolean | undefined, description: string }>({ id: '', image: '', localImage: '', published: false, description: ''});
  const [saveInjectLoading, setSaveInjectLoading] = useState<boolean>(false);
  const [showInjectMenu, setShowInjectMenu] = useState<string>('');
  
  const dispatch = useAppDispatch();

  const lastUserClickRef = useRef<string>()
  useEffect(() => {
    lastUserClickRef.current = props.lastUserClick;
  });

  const injectComponentsRef = useRef<IInject[]>([])
  useEffect(() => {
    injectComponentsRef.current = props.injectComponents;
  });

  const layoutsRef = useRef<{ [index: string]: ILayout[]; }>()
  useEffect(() => {
    layoutsRef.current = layouts;
  });

  const saveLayoutsRef = useRef<{ [index: string]: any[] }>()
  useEffect(() => {
    saveLayoutsRef.current = props.saveLayouts;
  });

  const rglElements: NodeListOf<Element> = document.querySelectorAll(".rgl-element");
  const rglElementsArray = Array.from(rglElements) as HTMLElement[]
  
  const lastClickTime = useRef<number>(0);

  const onClickEditInject = () => {
    const injectItem = injectComponentsRef.current!.find((item) => item.id === showInjectMenu);
    if (!injectItem) { return }
    props.setInjectItem(injectItem)
    setInjectDetails({ id: injectItem.id, image: injectItem.image, localImage: injectItem.localImage, published: injectItem.published !== undefined ? injectItem.published : false, description: injectItem.description })
    openInjectModal()
  }

  const onClickDeleteInject = () => {
    props.setLastUserClick(showInjectMenu);
    props.setInjectComponents(
      injectComponentsRef.current!.map((inject: IInject) => {
        if (showInjectMenu !== inject.id) {
          return inject;
        }
        return { ...inject, isSelected: 'selected' };
      })
    );

    let showHideObj: any = {};
    showHideObj.showDeleteBtn = 'show';
    showHideObj.showActionsMenu = 'hide';
    props.updateShowHide(showHideObj);
    props.openDeleteModal();
    setShowInjectMenu('');
  }

  const [injectMenuTop, setInjectMenuTop] = useState<number>();
  const [injectMenuLeft, setInjectMenuLeft] = useState<number>();
  const ref = useRef<HTMLDivElement>(null)

  const onClickInject = (e: MouseEvent) => {
    const clickTime = Date.now();
    const target = e.target as HTMLElement;
    const currentTarget = e.currentTarget as HTMLElement;
    if (layouts.injects !== undefined && layouts.injects.length !== 0) {
        layouts.injects.forEach((inj: ILayout) => {
            let rglElem: HTMLElement = document.createElement('div');
            for (let i=0; i<rglElementsArray.length; i++) {
              if (rglElementsArray[i].dataset.handleid === inj.i) {
                rglElem = rglElementsArray[i] as HTMLElement
              }
            }
            if (!isEmpty(rglElem)) {
              if (target) {
                
                let injectId: string = '';
                if (currentTarget.dataset.id! === undefined) {
                  injectId = currentTarget.dataset.handleid!
                } else {
                  injectId = currentTarget.dataset.id!
                }

                if (injectId === inj.i) {
                  if (target.classList.contains('inject-more-detail')) {
                    let myLayout = JSON.parse(JSON.stringify(layouts.injects))
                    for (let l = 0; l<myLayout.length; l++) {
                      if (myLayout[l].i === inj.i) {
                          if (target.classList.contains('inject-more-detail')) {
                            const box = rglElem.getBoundingClientRect();
                            const rootBox = ref.current?.getBoundingClientRect();
                            if (!rootBox) { return }
                            setInjectMenuTop(box.top - rootBox.top)
                            setInjectMenuLeft(box.left - rootBox.left + box.width)
                            setShowInjectMenu(injectId)
                          }
                      }
                    }
                  } else if (lastUserClickRef.current === inj.i && !target.classList.value.includes('inject-title') && !target.classList.contains('gray-ellipsis') && !target.classList.contains('inject-edit') && !target.classList.contains('inject-delete')) {
                    if (clickTime - lastClickTime.current <= 500) {
                      dblClickInject(inj.i)
                    }
                  } else if (target.classList.value.includes('inject-title') && lastUserClickRef.current === inj.i) {
                    const nameInput: HTMLInputElement = rglElem.querySelector('.inject-title') as HTMLInputElement;
                    if (nameInput !== null) {
                      nameInput.focus()
                      setTimeout(function() {
                        nameInput.select()
                      }, 250);
                    }
                  } else {
                    if (!target.classList.contains('gray-ellipsis')) {
                      props.setLastUserClick(inj.i)
                      props.setInjectComponents(injectComponentsRef.current!.map((inject: IInject) => {
                        if (inj.i === inject.id) {
                          return { ...inject, isSelected: 'selected' };
                        } else {
                          return inject;
                        }
                      }))
                      let showHideObj: any = {}
                      showHideObj.showDeleteBtn = 'show'
                      showHideObj.showActionsMenu = 'hide'
                      setShowInjectMenu('')
                      props.updateShowHide(showHideObj)
                    }
                  }
                }
              }
            }
          
        })
    }
    lastClickTime.current = clickTime;
  }

  useEffect(() => {
    if (layouts.injects !== undefined && layouts.injects.length !== 0) {
      layouts.injects.forEach((inj: ILayout) => {
          let rglElem: HTMLElement = document.createElement('div');
          for (let i=0; i<rglElementsArray.length; i++) {
            if (rglElementsArray[i].dataset.handleid === inj.i) {
              rglElem = rglElementsArray[i] as HTMLElement
            }
          }

          if (!isEmpty(rglElem)) {
            if (rglElem.getAttribute('listener') !== 'true') {
                rglElem.setAttribute('listener', 'true');
                rglElem.removeEventListener("mousedown", onClickInject)
                rglElem.addEventListener("mousedown", onClickInject)
              }
          }
      })
    }
  }, [layouts.injects, rglElementsArray]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let rgElement: HTMLElement = document.querySelector('.react-grid')!
    let turnsWrapper: HTMLElement = document.querySelector('.turns-wrapper')!
    turnsWrapper.style.height = rgElement.offsetHeight + 'px'
  })

  useEffect( () => {
    let injObjs: ILayout[] = []
    if (props.injectComponents.length > 0) {
        for (let i = 0; i<props.injectComponents.length; i++) {
          let injObj: ILayout = {
            i: props.injectComponents[i].id,
            x: props.injectComponents[i].startTurn - 1,
            y: props.injectComponents[i].turnOrder,
            w: props.injectComponents[i].turnLength,
            h: 1,
            isResizable: false,
            handleId: `inject${i}`,
          };
          injObjs.push(injObj)
        }
    }

    if (injObjs.length > 0) {
      if (props.zoomLevel === 5) {
        RRGL!.defaultProps!.rowHeight = 28;
        setBreakpoints({injects: (props.gameTimeInterval * 180)})
      } else {
        RRGL!.defaultProps!.rowHeight = 56;
        setBreakpoints({injects: (props.gameTimeInterval * 357)})
      }
      RRGL!.defaultProps!.cols = { injects: props.gameTimeInterval };

      if (layouts.injects !== undefined) {
        if (stableStringify(injObjs) !== stableStringify(layouts.injects)) {
          setLayouts({injects: injObjs})
        }
      } else {
        setLayouts({injects: injObjs})
      }
    }

}, [props.injectComponents, props.scenSnippets]) // eslint-disable-line react-hooks/exhaustive-deps

  const dblClickInject = (injectId: string) => {
    const inject = injectComponentsRef.current!.find((i: IInject) => i.id === injectId)
    if (inject) {
      props.setInjectItem(inject)
      props.setZoomLevel(1)
    }

    props.setInjectComponents(injectComponentsRef.current!.map((inject: IInject) => {
      saveLayoutsRef.current!.injects.forEach((inj: ILayout) => {
        if (inject.id === inj.i) {
          inject.startTurn = inj.x + 1;
          inject.turnOrder = inj.y;
          inject.turnLength = inj.w;
        }
      })
      return inject;
    }))
    setShowInjectMenu('');

    let showHide = {
        showSettings: 'hide',
        showLanding: 'hide',
        showTimeline: 'hidden',
        showNodeTimeline: 'show',
        showMiniTimeline: 'hide',
        showNodeInjMenu: 'show',
        showSideMenu: 'show',
        showDeleteBtn: 'hide',
        showActionsMenu: 'hide',
        showRGLTimeline: 'hidden'
      }
    props.updateShowHide(showHide);
    props.clickBranches({})
}

const openInjectModal = () => {
  setModalInjectIsOpen(true)
}

const closeInjectModal = () => {
  setModalInjectIsOpen(false)
}

const saveInjectModal = async () => {
  if (saveInjectLoading) {
    return;
  }
  setSaveInjectLoading(true)
  await props.saveScenario([]);
  setSaveInjectLoading(false)
}

const onInjectPublished = async () => {
  let publishResult = await dispatch(publishInject(injectDetails.id))
  
  if (publishResult.meta.requestStatus === "fulfilled") {
    props.setInjectComponents(injectComponentsRef.current!.map((inject: IInject) => {
      if (injectDetails.id === inject.id) {
        return { ...inject, published: !injectDetails.published };
      } else {
        return inject;
      }
    }))
    setInjectDetails({ id: injectDetails.id, image: injectDetails.image, localImage: injectDetails.localImage, published: !injectDetails.published, description: injectDetails.description  })
  }
}

  const generateDOM = () => {
    return layouts.injects?.map((l) => {
        return (
          <div key={l.i} className={`rgl-elem${l.handleId} rgl-element ${props.zoomLevel === 5 ? 'zoom-4-element' : ''}`} data-handleid={l.i}>
            <RGLInject updateShowHide={props.updateShowHide} isSelected={l.i === props.lastUserClick ? 'selected' : ''} setInjectComponents={props.setInjectComponents} setInjectItem={props.setInjectItem} injectComponents={props.injectComponents} clickBranches={props.clickBranches} id={l.i} zoomLevel={props.zoomLevel} setZoomLevel={props.setZoomLevel} scenSnippets={[]} turn={l.x} setSnippetModalIsOpen={props.setSnippetModalIsOpen} setSelectedSnippet={props.setSelectedSnippet} selectedScenario={props.selectedScenario} setSelectedScenario={props.setSelectedScenario} setNewSnippet={props.setNewSnippet} onChangeSave={props.onChangeSave} showInjectMenu={showInjectMenu} setShowInjectMenu={setShowInjectMenu} />
          </div>
        )
      }
    )
  }

  const onBreakpointChange = (breakpoint: string) => {
    //setCurrentBreakpoint(breakpoint)
  };

  const onLayoutChange = (layout: any) => {
    let injObjs: ILayout[] = []

    for (let i = 0; i<props.injectComponents.length; i++) {
      let injObj: ILayout = {
        i: props.injectComponents[i].id,
        x: props.injectComponents[i].startTurn - 1,
        y: props.injectComponents[i].turnOrder,
        w: props.injectComponents[i].turnLength,
        h: 1,
        isResizable: false,
        handleId: `inject${i}`,
      };
      injObjs.push(injObj);
    }

    if (stableStringify(injObjs) !== stableStringify(layout)) {
      let isDiff: boolean = false;
      injObjs.forEach((inject: any) => {
        layout.forEach((layout: any) => {
          if (inject.i === layout.i) {
            if (inject.x !== layout.x) {
              isDiff = true;
            }
            if (inject.y !== layout.y) {
              isDiff = true;
            }
          }
        });
      })

      if (isDiff) {
        setTimeout(() => {
          //props.saveScenario(injObjs);
          props.saveScenario(props.injectComponents);
        }, 1000)
      }
    }
    props.setSaveLayouts({ injects: layout });
    props.setInjectComponents(injectComponentsRef.current!.map((inject: IInject) => {
      layout.forEach((inj: any) => {
        if (inject.id === inj.i) {
          inject.startTurn = inj.x + 1;
          inject.turnOrder = inj.y;
          inject.turnLength = inj.w;
        }
      })
      return inject;
    }))
  };

  const onDrop = (layout: any, layoutItem: any, _event: any) => {
    console.log(`Dropped element props:\n${JSON.stringify(layoutItem, ['x', 'y', 'w', 'h'], 2)}`);
  };

  const onChangeDescription = (ev: React.ChangeEvent<HTMLTextAreaElement>) => {
    const target = ev.currentTarget as HTMLTextAreaElement;
    if (!target) { return; }

    props.setInjectItem({
        ...props.injectItem,
        description: target.value
    });

    props.setInjectComponents(props.injectComponents.map((inject: IInject) => {
        if (inject.id === props.injectItem.id) {
            return { ...inject, description: target.value, isChanged: true };
        } else {
            return inject;
        }
    }));

    target.style.height = 'auto'; // Setting auto first because otherwise scrollheight keeps growing even on delete.
    target.style.height = `${target.scrollHeight}px`;

    props.onChangeSave();
  }

  return (
      <div ref={ref} className={`react-grid ${props.showRGLTimeline}`} style={{ display: props.display, width: breakpoints.injects }}>
        <RRGL
          {...props}
          style={{ background: "none" }}
          layouts={layouts}
          breakpoints={breakpoints}
          measureBeforeMount={false}
          useCSSTransforms={true}
          compactType={"vertical"}
          preventCollision={false}
          isResizable={true}
          onLayoutChange={onLayoutChange}
          onBreakpointChange={onBreakpointChange}
          onDrop={onDrop}
          isDraggable={props.selectedScenario.published ? false : true}
          isDroppable
        >
          {generateDOM()}
        </RRGL>
        {!isEmpty(showInjectMenu) &&
        <div style={{position: 'absolute', top: injectMenuTop, left: injectMenuLeft}}>
          <div className={`inject-menu show`} id={`nodemenu${showInjectMenu}`}>
            <div className="menu-title">Choose an option</div>
            <img className="gray-ellipsis" src="img/gray-ellipsis.svg" alt="ellipsis" onClick={() => { setShowInjectMenu('') }}/>
            <div className="menu-item inject-edit" onClick={onClickEditInject}>Edit</div>
            <div className="menu-item inject-delete" onClick={onClickDeleteInject}>Delete</div>
          </div>
        </div>
        }
        <Modal
            isOpen={modalInjectIsOpen}
            onRequestClose={closeInjectModal}
            shouldCloseOnOverlayClick={false}
            style={customStyles}
            contentLabel="Inject Details"
            overlayClassName="inject-modal-overlay"
        >
            <div className="inject-image-text">Inject Name: <span>{props.injectItem.name}</span></div>

          <div className="inject-details-info">
              <div className="inject-details-label">
                <div className="inject-details-label-text">Description</div>
                <div className="inject-details-label-desc">Give your inject a brief description.</div>
              </div>
              <div className="inject-details-content">
                <textarea name="inject-description" className="inject-description" value={props.injectItem.description} onChange={onChangeDescription} disabled={props.selectedScenario.published ? true : false}></textarea>
              </div>
          </div>

          <div className="inject-details-info">
            <div className="inject-details-label">
                <div className="inject-details-label-text">Image</div>
                <div className="inject-details-label-desc">Upload an image for this inject. This image is used for the inject thumbnail.</div>
              </div>
            <div className="inject-details-content">
              { !props.selectedScenario.published ? 
              <Dropzone setSelectedScenario={props.setSelectedScenario} injectId={injectDetails.id} image={injectDetails.image} localImage={injectDetails.localImage} selectedScenario={props.selectedScenario} saveScenario={props.saveScenario} injectComponents={props.injectComponents} setInjectComponents={props.setInjectComponents} setInjectItem={props.setInjectItem} injectItem={props.injectItem} createInjectComponents={props.createInjectComponents} onChangeSave={props.onChangeSave} onError={props.onError} type="inject" /> : <></> }
            </div>
          </div>
          <div className="inject-details-info" style={{display: 'none'}}>
            <div className="inject-details-label">
                <div className="inject-details-label-text">Published</div>
                <div className="inject-details-label-desc">When published, this inject will be available for others to use in their scenarios.</div>
            </div>
            <div className="inject-details-content">
              <div className="checkbox-wrapper-8">
                  <input className="tgl tgl-ios" id="cb2-8" type="checkbox" value={injectDetails.published!.toString()} checked={injectDetails.published} onChange={onInjectPublished} disabled/>
                  <label className="tgl-btn" htmlFor="cb2-8"></label>
              </div>
            </div>
          </div>
          <button onClick={closeInjectModal} className="new-cancel-btn"><span>Close</span></button>
          { !props.selectedScenario.published ? <button onClick={saveInjectModal} className={`new-confirm-btn ${saveInjectLoading ? 'start-loading' : ''}`}>
              {saveInjectLoading ? <div className="game-save-loader-25"></div> : <></> }
              <span>Save</span>
          </button> : <></> }
        </Modal>
      </div>
    );
}

export default ReactGridLayout;

RRGL.defaultProps = {
  className: "layout",
  onLayoutChange: (layout: any) => {},
  cols: { injects: 20 },
  containerPadding: [0, 0],
  rowHeight: 56
};